import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import DeprecateIcon from './icons/Deprecate';

function Deprecated() {

    return (
        <Tooltip title="Deprecated">
            <span data-test="deprecated-icon" style={{
                textAlign: 'center',
                display: 'inline-block',
                paddingTop: '4px'
            }}>
                <DeprecateIcon fontSize="small" />
            </span>
        </Tooltip>
    );

}

export default Deprecated;